import { SITE_LEVEL_PAGE_ID, tpaPageIdToItemTypeConfig } from '@wix/a11y-wizard-common';
import { getPagesDataForAnalysis } from '@wix/ambassador-promote-accessibility-v2-rule-execution-result/http';
import { useErrorHandler, useHttpClient, useTranslation } from '@wix/fe-essentials/react';
import { fetchSiteStructure } from '../api/fetch-site-structure';
import { useA11yWizardAdapter } from './use-a11y-wizard-adapter';
export const useMapPageIdToPageDataFromServer = () => {
  const {
    a11yWizardAdapter
  } = useA11yWizardAdapter();
  const httpClient = useHttpClient();
  const i18n = useTranslation();
  const errorHandler = useErrorHandler();
  const mapPageIdToPageDataFromServer = async () => {
    const {
      pageToGroupMap
    } = a11yWizardAdapter.getPagesData();
    const {
      data
    } = await httpClient.request(getPagesDataForAnalysis({}));
    const {
      staticPages = [],
      templatePages = []
    } = data;
    const staticPageDataEntries = staticPages.map(page => [page.pageId ?? '', transformStaticPageToClientType(page, pageToGroupMap)]);
    const templatePageDataEntries = await Promise.all(templatePages.map(async page => [page.pageId ?? '', await transformTemplatePageToClientType(page, pageToGroupMap)]));
    const filteredTemplatePageDataEntries = templatePageDataEntries.filter(_ref => {
      let [_, {
        innerRoutes
      }] = _ref;
      return ((innerRoutes == null ? void 0 : innerRoutes.length) ?? 0) > 0;
    });
    const siteLevelPageData = [SITE_LEVEL_PAGE_ID, {
      dividerTitle: i18n.t('accessibility-wizard.rule-group.label.site-level'),
      itemType: 'SITE_LEVEL',
      title: i18n.t('accessibility-wizard.rule-group.label.site-level'),
      tpaPage: false,
      urlPath: ''
    }];
    return new Map([siteLevelPageData, ...staticPageDataEntries, ...filteredTemplatePageDataEntries]);
  };
  function transformStaticPageToClientType(page, pageToGroupMap) {
    const {
      pageId,
      membershipCustomPage,
      itemType,
      title,
      path
    } = page;
    return {
      dividerTitle: (pageId && pageToGroupMap[pageId]) ?? i18n.t('accessibility-wizard.groups-list.dividers-titles.default'),
      isMembershipCustomPage: membershipCustomPage ?? false,
      itemType: itemType,
      title: title ?? '',
      tpaPage: false,
      urlPath: path ?? ''
    };
  }
  async function transformTemplatePageToClientType(page, pageToGroupMap) {
    const {
      pageId,
      itemType,
      title,
      templatePageIntentId
    } = page;
    const itemTypeConfig = templatePageIntentId ? tpaPageIdToItemTypeConfig[templatePageIntentId] : undefined;
    const innerRoutes = itemTypeConfig ? await fetchSiteStructure(httpClient, itemTypeConfig, errorHandler) : undefined;
    return {
      dividerTitle: (pageId && pageToGroupMap[pageId]) ?? i18n.t('accessibility-wizard.groups-list.dividers-titles.default'),
      innerRoutes,
      itemType: itemType,
      title: title ?? '',
      tpaPage: true,
      urlPath: ''
    };
  }
  return mapPageIdToPageDataFromServer;
};
//# sourceMappingURL=use-map-page-id-to-page-data-from-server.js.map